import { appConfig } from '@common/config';
import { SearchForm } from '@components/SearchForm';
import { Index as DetailIndex } from '@components/detail/Index';
import { type IDicParams } from '@interface/IItemDic';
import { type IPriceParams } from '@interface/IItemPrice';
import { store, useAppDispatch } from '@store/index';
import { setIsFilterOpen } from '@store/priceSlice';
import { type ComponentType } from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router';
import { FilterWrapBnsNeo } from './FilterWrapBnsNeo';
import { FilterWrapLineageClassic } from './FilterWrapLineageClassic';
import { ResultWrap } from './ResultWrap';
import { useLocation } from 'react-router-dom';
import {Checkbox} from "@components/Checkbox";
import {Category} from "@components/Category";

const componentMap: Record<string, ComponentType<any>> = {
    bnsneo: FilterWrapBnsNeo,
    linclassic: FilterWrapLineageClassic,
};

const getSearchType = () => {
    const path = location.pathname;
    const match = path.match(/\/info\/(\w+)/);
    return match ? match[1] : 'item';
};

const searchType = getSearchType();

export async function loader({ request }: Record<string, any>): Promise<IDicParams> {
    const url = new URL(request.url as string);
    return {
        paramQuery: url.searchParams.get('query')?.replace(/%20/g, ' ') || null,
        paramGrade: url.searchParams.get('grade'),
        paramClass: url.searchParams.get('class'),
        paramElemental: url.searchParams.get('elementals'),
        paramAlignment: url.searchParams.get('aligns'),
        paramForm: url.searchParams.get('forms'),
        paramRegion1: url.searchParams.get('region1'),
        paramRegion2: url.searchParams.get('region2'),
        paramRegion3: url.searchParams.get('region3'),
        paramPage: url.searchParams.get('page'),
        paramCategory1: url.searchParams.get('category1'),
        paramCategory2: url.searchParams.get('category2'),
        paramFavorite: url.searchParams.get('favorite'),
        paramExactsearch: url.searchParams.get('exactsearch'),
        paramDetail: url.searchParams.get('detail'),
    };
}

const Main = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const params = useLoaderData() as IPriceParams;
    const CurrentFilter = componentMap[appConfig.service];

    return (
        <>
            {searchType === 'item' && (
                <SearchForm
                    props={{
                        placeholderStr:
                            appConfig.service === 'bns' ? t('common.placeholder2') :
                                appConfig.service === 'linclassic' ? t('common.placeholder3') :
                                    t('common.placeholder'),
                        watch: 'query',
                        value: params.paramQuery,
                        resetObj: { page: '1' },
                        apiPath: '/v2.0/dict/search/item/suggest',
                        submitCallback: (_q: string) => console.log('q', _q),
                    }}
                >
                    <button className="btn-filter" onClick={() => dispatch(setIsFilterOpen(!store.getState().price.isFilterOpen))}>
                        {t('price.searchconditionsbtn')}
                    </button>
                </SearchForm>
            )}
            {searchType === 'spell' && (
                <SearchForm
                    props={{
                        placeholderStr: t('common.placeholderspell'),
                        watch: 'query',
                        value: params.paramQuery,
                        resetObj: { page: '1' },
                        apiPath: '/v2.0/dict/search/spell/suggest',
                        submitCallback: (_q: string) => console.log('q', _q),
                    }}
                >
                    <button className="btn-filter" onClick={() => dispatch(setIsFilterOpen(!store.getState().price.isFilterOpen))}>
                        {t('price.searchconditionsbtn')}
                    </button>
                </SearchForm>
            )}
            {searchType === 'monster' && (
                <SearchForm
                    props={{
                        placeholderStr: t('common.placeholdermonster'),
                        watch: 'query',
                        value: params.paramQuery,
                        resetObj: { page: '1' },
                        apiPath: '/v2.0/dict/search/monster/suggest',
                        submitCallback: (_q: string) => console.log('q', _q),
                    }}
                >
                    <button className="btn-filter" onClick={() => dispatch(setIsFilterOpen(!store.getState().price.isFilterOpen))}>
                        {t('price.searchconditionsbtn')}
                    </button>
                </SearchForm>
            )}
            <div className="gameinfo-item-wrapper">
                <CurrentFilter props={params} />
                <ResultWrap params={params} />
                <div style={{ position: 'fixed', zIndex: 9999999, inset: 0, pointerEvents: 'none' }}>
                    <Toaster />
                </div>
            </div>

            <DetailIndex paramDetail={params.paramDetail} />
        </>
    );
};

export default Main;
